var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStickyApplicationSidebg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 59.605,
    height: 260.819,
    viewBox: "0 0 59.605 260.819",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 59.606,
    height: 260.819,
    transform: "translate(0 0)",
    fill: "#365bb8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_1851",
    "data-name": "Mask Group 1851",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2053",
    "data-name": "Group 2053",
    transform: "translate(-64.124 16.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2052",
    "data-name": "Group 2052",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(38.327 211.439) rotate(-138)",
    fill: "#ff8b01"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(15.023 205.392) rotate(-138)",
    fill: "#fee800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(22.553 165.281) rotate(-138)",
    fill: "#008143"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(32.592 124.029) rotate(-138)",
    fill: "#2d87ee"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(10.004 116.568) rotate(-138)",
    fill: "#a03ce9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(15.023 80.222) rotate(-138)",
    fill: "#9d11a0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    width: 13.461,
    height: 95.829,
    rx: 6.731,
    transform: "translate(28.941 252.326) rotate(-138)",
    fill: "#f91f19"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickyApplicationSidebg2);
export default __webpack_public_path__ + "static/media/sticky_application_sidebg2.f63b3e1c7aac1dbde00bc22c08dd801e.svg";
export { ForwardRef as ReactComponent };